/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type { ASTOToken, ASTOTokenInterface } from "../ASTOToken";

const _abi = [
  {
    inputs: [
      {
        internalType: "address",
        name: "agent",
        type: "address",
      },
      {
        internalType: "address",
        name: "finance",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "spender",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
    ],
    name: "Approval",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
    ],
    name: "Transfer",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        internalType: "address",
        name: "spender",
        type: "address",
      },
    ],
    name: "allowance",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "spender",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "approve",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "aragonAgent",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "aragonFinance",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "balanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "burn",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "burnFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "decimals",
    outputs: [
      {
        internalType: "uint8",
        name: "",
        type: "uint8",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "spender",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "subtractedValue",
        type: "uint256",
      },
    ],
    name: "decreaseAllowance",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "spender",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "addedValue",
        type: "uint256",
      },
    ],
    name: "increaseAllowance",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "mint",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "name",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "symbol",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "totalSupply",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "transfer",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "transferFrom",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "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";

export class ASTOToken__factory extends ContractFactory {
  constructor(
    ...args: [signer: Signer] | ConstructorParameters<typeof ContractFactory>
  ) {
    if (args.length === 1) {
      super(_abi, _bytecode, args[0]);
    } else {
      super(...args);
    }
  }

  deploy(
    agent: string,
    finance: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<ASTOToken> {
    return super.deploy(agent, finance, overrides || {}) as Promise<ASTOToken>;
  }
  getDeployTransaction(
    agent: string,
    finance: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(agent, finance, overrides || {});
  }
  attach(address: string): ASTOToken {
    return super.attach(address) as ASTOToken;
  }
  connect(signer: Signer): ASTOToken__factory {
    return super.connect(signer) as ASTOToken__factory;
  }
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): ASTOTokenInterface {
    return new utils.Interface(_abi) as ASTOTokenInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): ASTOToken {
    return new Contract(address, _abi, signerOrProvider) as ASTOToken;
  }
}
